"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatError = formatError;
exports.formatValidationError = formatValidationError;
exports.getStackTrace = getStackTrace;
const nested_error_stacks_1 = __importDefault(require("nested-error-stacks"));
function formatError(...errors) {
    const result = [];
    for (const error of errors) {
        result.push({ msg: error });
    }
    return { errors: result };
}
function formatValidationError(error) {
    const msg = error.details.map(({ message }) => message);
    return formatError(...msg);
}
function getStackTrace(error) {
    return new nested_error_stacks_1.default(undefined, error).stack || '';
}
